var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E9F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9141 37.1367C29.2339 37.1367 36.7891 29.5815 36.7891 20.2617C36.7891 10.9419 29.2339 3.38672 19.9141 3.38672C10.5943 3.38672 3.03906 10.9419 3.03906 20.2617C3.03906 29.5815 10.5943 37.1367 19.9141 37.1367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9152 33.5198C27.2379 33.5198 33.1741 27.5836 33.1741 20.2609C33.1741 12.9382 27.2379 7.00195 19.9152 7.00195C12.5925 7.00195 6.65625 12.9382 6.65625 20.2609C6.65625 27.5836 12.5925 33.5198 19.9152 33.5198Z",
    fill: "#D5E7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9146 31.1085C25.9059 31.1085 30.7628 26.2516 30.7628 20.2603C30.7628 14.269 25.9059 9.41211 19.9146 9.41211C13.9233 9.41211 9.06641 14.269 9.06641 20.2603C9.06641 26.2516 13.9233 31.1085 19.9146 31.1085Z",
    fill: "#4492FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 23.2734H24.7366V25.0815C24.7366 25.4129 24.4654 25.6842 24.1339 25.6842H15.6964C15.365 25.6842 15.0938 25.4129 15.0938 25.0815V23.2734Z",
    fill: "#B1D1FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2792 16.3862L23.4105 17.9109C23.1332 18.0556 22.7957 17.9592 22.633 17.6759L20.4272 13.9272C20.1922 13.5295 19.6437 13.5295 19.4087 13.9272L17.2029 17.6759C17.0402 17.9531 16.7027 18.0556 16.4254 17.9109L13.5567 16.3862C13.0565 16.121 12.5201 16.6574 12.737 17.1998L15.0995 23.2748H24.7424L27.1049 17.1998C27.3219 16.6513 26.7794 16.121 26.2853 16.3862H26.2792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPoints);
export default __webpack_public_path__ + "static/media/myPoints.e5b5ee1a616cbb5be7452f24ee06c26b.svg";
export { ForwardRef as ReactComponent };